
const state = {
	mainSearchHandle : {},
	isDisabled : true,
	searchKeyword : '',// 全局搜索值
}

const mutations = {
	changeMainSearchHandle (state,payload){
		state.mainSearchHandle = payload;
	},
	changeSearchDisabled (state,payload){
		state.isDisabled = payload;
	},
	changeSearchKeyword (state,payload){
		state.searchKeyword = payload;
	}
}

export default {
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/storage/vuex/module/mainSearch.js